import SplitType from 'split-type'
import { WrapLines } from './utilities'

export const splitType = () => {
	const split = new SplitType('[data-split]', { types: 'lines' })
	const splitChars = new SplitType('[data-chars]', { types: 'words, chars' })
	const splitCharsInner = new SplitType('[data-chars-inner] p', { types: 'words, chars' })

	WrapLines(split.lines, 'div', 'line-mask')
}

export default () => {}
 